module.exports = __webpack_public_path__ + "media/video402.f583e0d3.mp4";